// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .app-loader {
  display: flex;
  transition: opacity 0.3s;
}

.mode-fit-container {
  z-index: 900;
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
}

.mode-fullscreen {
  z-index: 999;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.app-loader-overlay {
  pointer-events: auto;
  cursor: wait;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -16px;
  margin-top: -11px;
}

.loading > div {
  display: inline-block;
  width: 4px;
  height: 18px;
  border-radius: 4px;
  animation: loading 0.8s ease-in-out infinite;
}

.loading div + div {
  margin-left: 5px;
}

.loading .bar1 {
  background-color: #FFA726;
  animation-delay: 0s;
}

.loading .bar2 {
  background-color: #FFA726;
  animation-delay: 0.09s;
}

.loading .bar3 {
  background-color: #FFA726;
  animation-delay: 0.18s;
}

.loading .bar4 {
  background-color: #FFA726;
  animation-delay: 0.27s;
}

@keyframes loading {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1, 2.2);
  }
  40% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/app-loader/app-loader.component.scss"],"names":[],"mappings":"AAAA;EACG,aAAA;EACA,wBAAA;AACH;;AAEA;EACG,YAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AACH;;AAEA;EACG,YAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;AACH;;AAEA;EACG,oBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;AACH;;AAEA;EACG,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;AACH;;AAEA;EACG,qBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,4CAAA;AACH;;AAEA;EACG,gBAAA;AACH;;AAEA;EACG,yBAAA;EACA,mBAAA;AACH;;AAEA;EACG,yBAAA;EACA,sBAAA;AACH;;AAEA;EACG,yBAAA;EACA,sBAAA;AACH;;AAEA;EACG,yBAAA;EACA,sBAAA;AACH;;AAEA;EACG;IACG,mBAAA;EACJ;EAEC;IACG,wBAAA;EAAJ;EAGC;IACG,mBAAA;EADJ;AACF","sourcesContent":["::ng-deep .app-loader {\n   display: flex;\n   transition: opacity .3s;\n}\n\n.mode-fit-container {\n   z-index: 900;\n   position: fixed;\n   left: 0px;\n   top: 0px;\n   right: 0px;\n   bottom: 0px;\n}\n\n.mode-fullscreen {\n   z-index: 999;\n   position: fixed;\n   left: 0;\n   top: 0;\n   right: 0;\n   bottom: 0;\n}\n\n.app-loader-overlay {\n   pointer-events: auto;\n   cursor: wait;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   flex: 1;\n}\n\n.loading {\n   position: absolute;\n   top: 50%;\n   left: 50%;\n   margin-left: -16px;\n   margin-top: -11px;\n}\n\n.loading>div {\n   display: inline-block;\n   width: 4px;\n   height: 18px;\n   border-radius: 4px;\n   animation: loading .8s ease-in-out infinite;\n}\n\n.loading div+div {\n   margin-left: 5px;\n}\n\n.loading .bar1 {\n   background-color: #FFA726;\n   animation-delay: 0s;\n}\n\n.loading .bar2 {\n   background-color: #FFA726;\n   animation-delay: 0.09s;\n}\n\n.loading .bar3 {\n   background-color: #FFA726;\n   animation-delay: .18s;\n}\n\n.loading .bar4 {\n   background-color: #FFA726;\n   animation-delay: .27s;\n}\n\n@keyframes loading {\n   0% {\n      transform: scale(1);\n   }\n\n   20% {\n      transform: scale(1, 2.2);\n   }\n\n   40% {\n      transform: scale(1);\n   }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
